/**
 * @Date: 2022-07-14 14:55:25
 * @LastEditTime: 2022-07-14 14:55:25
 * @Description: 项目配置
 */

// api URL地址(单个baseUrl)
const apiUrl = 'http://api.byszx.cn' // 线上环境
// const apiUrl = 'http://localhost:8099'   // 测试环境

// 图片 URL地址y

const imgUrl = ''


// 免登录白名单
const whiteList = []

export default {
    name: 'client', // 项目名
    version: '1.0.0', // 版本号
    apiUrl,
    imgUrl,
    whiteList
}
